import { ui } from "@/components/ui";
import { zodResolver } from "@hookform/resolvers/zod";
import { type SubmitHandler, useForm } from "react-hook-form";

import { formComponents as fc } from "@/components/form";
import usePasswordLoginMutation from "@/features/auth/hooks/usePasswordLoginMutation";
import {
	type LoginSchemaType,
	loginSchema,
} from "@/features/auth/types/loginSchema";

interface Props {
	email?: string;
	shouldNavigate?: boolean;
}
const LoginForm = (props: Props) => {
	const form = useForm<LoginSchemaType>({
		resolver: zodResolver(loginSchema),
		defaultValues: {
			email: props.email ?? "",
			password: "",
		},
	});

	const { mutate: loginMutation, isPending } = usePasswordLoginMutation({
		shouldNavigate: props.shouldNavigate ?? true,
	});

	const onSubmit: SubmitHandler<LoginSchemaType> = async (formData) => {
		await loginMutation(formData);
	};

	return (
		<ui.Form {...form}>
			<form onSubmit={form.handleSubmit(onSubmit)} className="form">
				{/* Email */}
				<fc.Email tabIndex={0} />

				<fc.Password
					tabIndex={0}
					showPassword={true}
					showRequirements={false}
				/>

				<ui.Button tabIndex={0} size="lg" type="submit" disabled={isPending}>
					{isPending ? "Logging in..." : "Next"}
				</ui.Button>
			</form>
		</ui.Form>
	);
};

export default LoginForm;
